module.exports = __webpack_public_path__ + "static/img/bg_4.2b1155c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_4.png
// module id = TeCc
// module chunks = 1